import React from "react";
import { Link } from "react-router-dom";
import _ from "lodash";

import Back from "../widgets/Back";

import { defaultColors, other } from "../../constants/defaults";
import Utils from "../../helpers/Utils";
import Colors from "../../helpers/Colors";
import { Routes } from "../../constants/Routes";
import { createUrl } from "../../utils/UrlUtils";

export default class AppointmentStatusColor extends React.Component {
  selectColor = (item) => {
    return () => {
      Colors.selectAppointmentStatus(_.get(this, "props.match.params.colorCode"), item);
      this.forceUpdate();
    };
  };

  render() {
    const colorCode = _.get(this, "props.match.params.colorCode");
    const activeStatus = Colors.getStatusColor(colorCode);

    let $colors = Utils.objectToArray(defaultColors, (item) => {
      const checkActive = activeStatus.color.code === item.code ? " active" : "";

      return (
        <button key={item.code} onClick={this.selectColor(item)} className="list-group-item">
          <div className={"pull-right check" + checkActive}>✔</div>
          <div className="color" style={{ backgroundColor: item.color }} />
          {item.name}
        </button>
      );
    });

    let listOther = other;
    let otherActive = "";

    if (activeStatus.color.code === other.code) {
      otherActive = " active";
      listOther = activeStatus.color;
    }

    return (
      <div className="settings-body">
        <div className="title">
          <Back />
          <div className="name">{activeStatus.name}</div>
        </div>
        <div className="body">
          <div className="list-group">
            {$colors}
            <Link
              to={createUrl(Routes.SettingsAppointmentStatusOther, {
                params: {
                  colorCode,
                },
              })}
              className="list-group-item"
            >
              <div className={"pull-right check" + otherActive}>✔</div>
              <div className="color" style={{ backgroundColor: listOther.color }} />
              {listOther.name}
            </Link>
          </div>
        </div>
      </div>
    );
  }
}
